import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { DropdownType } from '@editor/src/js/constants/toolbar-data';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { wrapIdForCommon, wrapIdForPic, wrapIdForText } from '@framework/workbench/util/wrap-id-util';
import { TOOLBAR_DROPDOWN, TOOLBAR_FILLCOLOR } from '@editor/src/img/pageIndex';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.FILLCOLOR,
    tipMsg: i18n.t('填充颜色'),
    title: i18n.t('填充颜色'),
    icon: TOOLBAR_FILLCOLOR,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.COLOR,
    },
    twdConfig: {
        action: TDWActionType.FILL_COLOR,
        handleFunction: value => ({
            ver5: value?.solidFill?.color?.colorValue,
        }),
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        hasArrow: true,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: wrapIdForText(config.id),
        hasArrow: true,
        text: i18n.t('填充颜色'),
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        style: {
        },
    },
    {
        name: wrapIdForCommon(config.id),
        hasArrow: true,
        text: i18n.t('填充色'),
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        style: {
        },
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        style: {
            width: 249,
            overflow: 'hidden',
            padding: 0,
            height: 'auto',
        },
    },
];
